<template>
    <div id="menu" class="my-menu z-10" :class="{ show: shifted }">
        <div class="my-menu__close" @click="closeMenu">
            <span class="icon-times"></span>
        </div>

        <ul class="my-menu__catalogues" v-if="$application && $application.database && $application.database.catalogues">
            <template v-for="(catalogue, index) in $application.database.catalogues">
                <li v-if="catalogue.chapters.length" class="my-menu__catalogues-container" @click="handleClick(index); trackClick(catalogue)">
                    <h2 class="my-menu__catalogues__name" :class="{ has_chapters: catalogue.chapters.length }">
                        {{ catalogue.name }}
                    </h2>
                    <span v-if="catalogue.chapters && catalogue.chapters.length" class="icon-angle-up" :class="{ active: activeIndex == index }" :ref="'icon-' + index"></span>

                    <ul :ref="'chapters-' + index" class="my-menu__catalogues__chapters">
                        <template v-if="catalogue.accesible">
                            <li v-for="chapter in catalogue.chapters" :class="{ unavailable_chapter: chapter.disabled }">
                                <template v-if="chapter && !chapter.length">
                                    <span v-if="chapter.disabled" v-html="chapter.name">

                                    </span>
                                    <a v-else :_href="$application.helpers.getLinkAndValues(window.location.href, catalogue.href, {
                                        'chapter': chapter.slug,
                                    })" target="_self" class="text-white pointer" @click="openCatalog(chapter)" v-html="chapter.name">
                                    </a>

                                </template>
                                <template v-else>
                                    <router-link :to="{
                                        name: 'catalogue',
                                        params: {
                                            slug_catalogue: catalogue.slug,
                                            slug_catalogue: catalogue.slug,
                                        }
                                    }" class="text-white" v-html="catalogue.name">
                                    </router-link>
                                </template>
                            </li>
                        </template>

                        <template v-else>
                            <li>
                                <a class="text-gray-300 border-transparent" v-html="catalogue.name"></a>
                            </li>
                        </template>
                    </ul>
                </li>
                <li v-else>
                    <a class="my-menu__catalogues__name" :_href="$application.helpers.getLinkAndValues(window.location.href, catalogue.href, {
                        'catalogue': catalogue.slug,
                    })" target="_self" @click="openCatalog(catalogue)">{{ catalogue.name }}</a>
                </li>
            </template>
        </ul>

    </div>
</template>

<script>
export default {
    name: "Menu",
    data: function () {
        return {
            visible: false,
            activeIndex: null,
            isTransitioning: false,
        }
    },
    props: {
        shifted: {
            type: Boolean,
            default: false,
        }
    },
    methods: {
        showMenu() {
            this.visible = true;
        },
        hideMenu(a) {
            this.visible = false;
            // console.log('hideMenu', a);
        },

        async handleClick(index) {
            let self = this;

            if (self.isTransitioning) return;

            self.isTransitioning = true;

            if (self.activeIndex != null && self.activeIndex !== index) {
                const current = self.$refs['chapters-' + self.activeIndex];

                if (current) {
                    current[0].classList.remove('open');
                }
                await self.waitTime(500);
            }

            const clicked = self.$refs['chapters-' + index];

            if (self.activeIndex === index) {

                if (clicked) {
                    clicked[0].classList.remove('open');
                }
                self.activeIndex = null;
            } else {
                if (clicked) {
                    clicked[0].classList.add('open');
                }
                self.activeIndex = index;
            }

            self.isTransitioning = false;
        },


        openCatalog(catalogueObj) {
            var url = $application.helpers.getLinkAndValues(window.location.href, catalogueObj.href, {
                'catalogue': catalogueObj.slug,
            })

            var trackingCallback = function () {
                console.log("trackingCallback openCatalog url=" + url);
                setTimeout(function () {
                    window.location.href = url;
                }, 300);
            }

            this.trackEvent("cta_click:" + catalogueObj.name, { "name": catalogueObj.name, "event_callback": trackingCallback });
        },

        trackClick(catalogueObj) {
            //gtag('event', 'catalogue_click')

            if (catalogueObj) {
                this.trackEvent("cta_click:" + catalogueObj.name, { "name": catalogueObj.name });
            }
        },

        waitTime(ms) {
            return new Promise(resolve => setTimeout(resolve, ms))
        },

        toggleCatalogues(index) {
            let self = this;

            if (self.activeIndex === index) {
                self.activeIndex = null;
            } else {
                setTimeout(() => {
                    self.activeIndex = index;
                }, 3);
            }
        },

        // capitalizeFirstLetter(name) {
        //     if (!name) {
        //         return ''
        //     };

        //     return name.charAt(0).toUpperCase() + name.slice(1).toLowerCase();
        // },

        closeMenu() {
            //this.trackEvent("Menu:SummaryClose",  {});
            this.trackEvent("cta_click:SummaryClose", {});

            $eventbus.$emit('close-menu');
        },
    },
    mounted() {
        const vm = this;

        window.addEventListener('resize', vm.hideMenu);

        window.addEventListener('click', function (e) {
            let este = e.target.closest('.btn-menu') || e.target.closest('.my-menu') || e.target.closest('.btn-my-account');
            console.log({ este });
            if (!este) {
                vm.hideMenu();
            }
        });
    }
}
</script>

<style scoped lang="scss">
.my-menu {
    @apply fixed top-0 left-0 w-80 h-full text-white hidden justify-center pl-4 py-8 pt-16;
    background-color: #0a133a;
    font-family: inherit;

    @media (max-width: 1023px) {
        top: 83px;
        width: 100%;
    }

    &.show {
        @apply flex;
    }


    &__close {
        @apply absolute flex justify-center items-center top-7 left-4 w-8 h-8 text-white cursor-pointer p-2 text-3xl
    }

    &__catalogues {
        @apply w-full mt-10;

        padding-bottom: 1.5rem;
        height: 100%;
        overflow-y: auto;

        @media (max-width: 1023px) {
            height: calc(100dvh - 180px);
            padding-bottom: unset;
            margin-top: 0.5rem;
        }

        &__name {
            display: inline-flex;
            // justify-content: space-between;
            width: 89%;
            padding: 0.25rem 0.5rem;
            font-size: 18px;
            font-weight: bold;
            font-family: 'Montserrat-Regular', sans-serif;
            cursor: pointer;

            @media (max-width: 1023px) {
                font-size: 13px;
            }

            &:hover {
                text-decoration: underline;
            }

        }

        .icon-angle-up {
            @apply transform -rotate-180 text-2xl pointer-events-none ease-in-out duration-300;
            padding-right: 4px;

            @media (max-width: 1023px) {
                padding-right: 12px;
            }

            display: inline-flex;
            width: fit-content;
        }

        &__chapters {
            @apply relative block w-full overflow-hidden leading-normal;
            max-height: 0;
            // transition: max-height 0.7s ease-in-out;
            transition: all 0.7s ease-in-out;
            background-color: #4e63b6;
            font-family: 'Montserrat-Regular', sans-serif;
            // display: block !important;

            &>li {
                padding: 0.15rem 1rem;

                &.unavailable_chapter {
                    font-style: italic;
                    color: #ccc;
                    opacity: 0.7;
                    cursor: text;

                    &>a {
                        &:hover {
                            text-decoration: none;
                        }
                    }
                }

                &>a {
                    @apply leading-none;
                    word-wrap: break-word;

                    &:hover {
                        @apply border-b;
                    }
                }
            }

        }

        &>li.my-menu__catalogues-container {
            overflow: hidden;
            cursor: pointer;

            @media (max-width: 1023px) {
                font-size: 13px;
            }

            &.active {
                span {
                    @apply rotate-0;
                    padding-left: 12px;
                }

                .my-menu__catalogues__chapters {
                    max-height: 1500px;
                }
            }

        }
    }

    .open {
        max-height: 1500px;
    }

    .active {
        @apply rotate-0;

        padding-left: 4px;
        
        @media (max-width: 1023px) {
            padding-right: 12px;
            padding-left: 12px;
        }
    }

    .icon-angle-up {
        height: fit-content;
    }
}
</style>
